export const enviroment = {
  baseUrl: "https://habitaki.com.br/",
};
